var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"social-button component",attrs:{"unselectable":"on","type":_vm.type,"title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }